import Vue from 'vue'
import MarketContainer from '@made-people/centra-storyblok-nuxt-shared/lib/components/MarketContainer'
Vue.component('MarketContainer', MarketContainer)
